import React, { lazy, Suspense } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {
  esES as esMuiPickerLocale,
  enUS as enMuiPickerLocale
} from '@mui/x-date-pickers-pro/locales'
import { es as esDateFnsLocale, enUS as enDateFnsLocale } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

import { FullPageLoading } from 'components'
import { useThemeType } from 'context/theme'
import { themeConfig } from 'config'
import { useUser } from 'context/auth/user'
import { useAuth } from 'context/auth/auth'

const Authenticated = lazy(() => import('./screens/Authenticated'))
const Unauthenticated = lazy(() => import('./screens/Unauthenticated'))

const App = () => {
  const { firstLoading } = useAuth()
  const { firebaseUser } = useUser()
  const {
    i18n: { language }
  } = useTranslation()
  const { themeType } = useThemeType()
  const theme = themeConfig(themeType, language)
  const pickerLocale = language === 'es' ? esMuiPickerLocale : enMuiPickerLocale
  const dateFnsLocale = language === 'es' ? esDateFnsLocale : enDateFnsLocale

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<FullPageLoading />}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={dateFnsLocale}
          localeText={
            pickerLocale.components.MuiLocalizationProvider.defaultProps
              .localeText
          }
        >
          {firstLoading ? (
            <FullPageLoading />
          ) : firebaseUser && firebaseUser?.emailVerified ? (
            <Authenticated />
          ) : (
            <Unauthenticated />
          )}
        </LocalizationProvider>
      </Suspense>
    </ThemeProvider>
  )
}

export default App
